import React, { useEffect, useState } from "react";
import Modal from "@/components/chat/Modal";
import api from "@/lib/api";
import { toast } from "sonner";
import { Trash2, Clock } from "lucide-react";

export default function ScheduleDialog({ chatId, onClose }) {
  const [text, setText] = useState("");
  const [when, setWhen] = useState("");
  const [pending, setPending] = useState([]);

  const load = () => api.get(`/chats/${chatId}/scheduled`).then(({ data }) => setPending(data)).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const schedule = async () => {
    if (!text.trim() || !when) return toast.error("Add a message and a time");
    if (new Date(when).getTime() <= Date.now()) return toast.error("Pick a future time");
    try {
      await api.post("/messages/schedule", { chat_id: chatId, type: "text", text: text.trim(), send_at: new Date(when).toISOString() });
      setText(""); setWhen(""); load(); toast.success("Message scheduled");
    } catch { toast.error("Could not schedule"); }
  };
  const cancel = async (id) => { await api.delete(`/scheduled/${id}`); load(); };

  return (
    <Modal title="Schedule message" onClose={onClose}>
      <div className="space-y-3" data-testid="schedule-dialog">
        <textarea value={text} onChange={(e) => setText(e.target.value)} rows={3} placeholder="Message to send later…" data-testid="schedule-text"
          className="w-full resize-none bg-[var(--rc-bg)] border border-[var(--rc-border)] rounded-xl px-4 py-3 focus:outline-none focus:border-[var(--rc-gold)]/50" />
        <input type="datetime-local" value={when} onChange={(e) => setWhen(e.target.value)} data-testid="schedule-when"
          className="w-full bg-[var(--rc-bg)] border border-[var(--rc-border)] rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-[var(--rc-gold)]/50" />
        <button onClick={schedule} data-testid="schedule-btn" className="w-full rounded-xl bg-[var(--rc-gold)] text-black font-semibold py-3">Schedule</button>
        {pending.length > 0 && (
          <div>
            <p className="text-sm font-medium mb-2 mt-2">Scheduled</p>
            <div className="space-y-2">
              {pending.map((p) => (
                <div key={p.id} className="flex items-center gap-2 rounded-xl bg-[var(--rc-bg)] border border-[var(--rc-border)] p-3" data-testid={`scheduled-item-${p.id}`}>
                  <Clock size={15} className="text-[var(--rc-gold)] shrink-0" />
                  <div className="min-w-0 flex-1"><div className="text-sm truncate">{p.text}</div><div className="text-[11px] text-[var(--rc-muted)]">{new Date(p.send_at).toLocaleString()}</div></div>
                  <button onClick={() => cancel(p.id)} data-testid={`cancel-scheduled-${p.id}`} className="text-red-400"><Trash2 size={15} /></button>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}
